export default __webpack_public_path__ + "static/media/arrow-right.2746ee49.svg";